module.exports = __webpack_public_path__ + "img/back.00f67dd5.png";